import React, { useState } from 'react';
import { Modal, Button, Form, Input, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { createCompany } from '../../../redux/Company/actions';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const AddCompanyButton = ({ onRefresh }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const countries = useSelector((state) => state.countries.countries || []);

  const showModal = () => {
    setVisible(true);
  };

  const hideModalOk = () => {
    form.submit();
  };

  const formOnFinish = (values) => {
    dispatch(createCompany(values)).then(() => {
      onRefresh();
    });
    form.resetFields();
    setVisible(false);
  };

  const hideModalCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        + Add Company
      </Button>
      <Modal
        title="Add Company"
        visible={visible}
        onOk={hideModalOk}
        onCancel={hideModalCancel}
        okText="Submit"
        cancelText="Close"
      >
        <Form
          {...layout}
          form={form}
          onFinish={formOnFinish}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter the company name!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Address"
            name="address"
            rules={[{ required: true, message: 'Please enter the address!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="URL"
            name="url"
            rules={[{ required: true, message: 'Please enter the company URL!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[{ required: true, message: 'Please enter a description!' }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="Country"
            name="country"
            rules={[{ required: true, message: 'Please select a country!' }]}
          >
            <Select placeholder="Select a country">
              {countries.map((country) => (
                <Select.Option key={country._id} value={country._id}>
                  {country.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddCompanyButton;
